import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const rol = params.get('rol');

    console.log('URL:', window.location.href);
    console.log('Token:', token);
    console.log('Rol:', rol);

    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('rol', rol || '');
      window.location.href = '/';
    } else {
      console.log('Token yok, login e gidiyorum');
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', fontFamily:'sans-serif', flexDirection:'column', gap:12 }}>
      <div>Giriş yapılıyor...</div>
      <div style={{fontSize:12, color:'#aaa'}}>Lütfen bekleyin...</div>
    </div>
  );
};

export default AuthCallback;
